import React from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-white border-t border-gray-100 py-6">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-center">
          <Link 
            to="/privacy" 
            className="text-sm text-gray-500 hover:text-gray-700 transition-colors duration-200"
          >
            Integritetspolicy
          </Link>
        </div>
        <div className="text-center space-y-2 mt-4">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} Utlysningslabbet
          </p>
          <p className="text-sm text-gray-400 flex items-center justify-center gap-1">
            Made with <Heart size={14} className="text-green-500 fill-green-500" /> in Stockholm
          </p>
        </div>
      </div>
    </footer>
  );
}